import api from 'config/axios';
import AppService from 'common/app-service';

export default class MetabaseService extends AppService {
  constructor() {
    super('metabase', api);
  }

  async getPainelGarantiaUrl(carrierRootId?: number, financierId?: number): Promise<string> {
    const params: { carrierRootId?: number; financierId?: number } = {};
    if (carrierRootId != null) params.carrierRootId = carrierRootId;
    if (financierId != null) params.financierId = financierId;
    const { data } = await this.api.get<{ url: string }>('/metabase/painel-garantia', {
      params: Object.keys(params).length ? params : undefined,
    });
    return data.url;
  }
}
